
class Resources {
    APP_NAME = "";
    BACKEND_SIDE_BASE_URL = "https://api.gigagates.com/youandme-delivery-backend";//
}

export default Resources;